import React, { useEffect, useState } from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Typography, Box, IconButton, Paper, Tooltip, Chip } from '@mui/material';
import { colors } from 'utils/colorsSteps';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionIcon from '@mui/icons-material/Description';
import { CERTIFICATE_TYPES } from 'constants/investigated-certificate-types';
import TimelineIcon from '@mui/icons-material/Timeline';
import ArticleIcon from '@mui/icons-material/Article';
import ModalHistoryIntimation from 'components/ModalHistoryIntimation';
import ModalGenerateAndMonitorNoticePublic from 'components/ModalGenerateAndMonitorNoticePublic';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#ededed',
    height: '100%',
    overflow: 'auto',
  },
  shadow: {
    boxShadow: `0px 33px 0px 0px ${colors.greenLight} inset`,
    height: '100%',
    padding: theme.spacing(1),
  },
  containerTypography: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'start',
    },
    marginBottom: theme.spacing(2),
    marginTop: '-5px',
    alignItems: 'center',
  },
  typography: {
    display: 'inline-block',
  },
  title: {
    fontWeight: 'bold',
  },
  chip: {
    backgroundColor: colors.greenLight,
    color: '#ededed',
    fontSize: 12,
    fontWeight: 'bold',
  },
  chipContact: {
    backgroundColor: colors.navBar,
    color: '#ededed',
    fontSize: 11,
    fontWeight: 'bold',
    margin: theme.spacing(0.5),
    height: 20,
  },
  containerChips: {
    display: 'flex',
    justifyContent: 'space-stretch',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  containerBtns: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  containerBtn: {
    padding: theme.spacing(2),
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
  },
  iconButton: {
    backgroundColor: colors.greenLight,
    '&:hover': {
      backgroundColor: colors.greenLight,
    },
  },
  icon: {
    color: '#fff',
  },
  labelIntimationStatus: {
    color: '#ededed',
    fontSize: 16,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  historyButton: {
    background: 'white',
    borderRadius: '50%',
  },
}));

const StatusIntimation = props => {
  const {
    intimations,
    setOpenModalAddFile,
    setOpenModalListFile,
    write,
    handleOpenSnackbar,
    disabledAddFileIntimation,
    inquiry,
    onRefresh,
    getIntimations,
  } = props;
  const [attempts, setAttempts] = useState([]);
  const [openHistoryIntimationModal, setOpenHistoryIntimationModal] = useState(false);
  const [openGenerateNoticeModal, setOpenGenerateNoticeModal] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (intimations.length > 0) {
      setAttempts(intimations[0].attempts);
    }
  }, [intimations]);

  const handleOpenModalHistoryIntimation = () => {
    setOpenHistoryIntimationModal(true);
  };

  const handleCloseModalHistoryIntimation = () => {
    setOpenHistoryIntimationModal(false);
  };

  const handleOpenGenerateNoticeModal = () => {
    setOpenGenerateNoticeModal(true);
  };

  const handleCloseGenerateNoticeModal = () => {
    setOpenGenerateNoticeModal(false);
  };

  const statusToShowNoticeButton = [
    'AWAITING_NOTICE', 
    'MANUAL_PUBLISHED_NOTICE', 
    'PUBLISHED_NOTICE'
  ];

  const hasOnlyNoticeAttemptRemaining = () => {
    if (intimations.length === 0) {
      return false;
    }

    const targetIntimation = intimations[0];
    if (!targetIntimation) {
      return false;
    }

    return statusToShowNoticeButton.includes(targetIntimation.noticeStatus);
  };

  const TextStatus = () => {
    return (
      <Typography
        className={classes.labelIntimationStatus}
      >
        {intimations.length > 0
          ? intimations[0].status === 'AWAITING_RESPONSE'
            ? 'Aguardando resposta da intimação'
            : intimations[0].status === 'CANCELED'
            ? 'Intimação não executada'
            : intimations[0].status === 'FAILED'
            ? 'Intimação não executada'
            : intimations[0].status === 'SUCCESS'
            ? 'Intimação realizada com sucesso'
            : 'Não intimado'
          : 'Não intimado'}
        <div className={classes.buttonsContainer}>
          <Tooltip arrow placement="top" title="Ver histórico">
            <span className={classes.historyButton}>
              <IconButton
                size="small"
                onClick={() => handleOpenModalHistoryIntimation()}
              >
                <TimelineIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          {hasOnlyNoticeAttemptRemaining() && (
            <Tooltip arrow placement="top" title="Gerar edital">
              <span className={classes.historyButton}>
                <IconButton
                  size="small"
                  onClick={() => handleOpenGenerateNoticeModal()}
                >
                  <ArticleIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      </Typography>
    );
  };

  return (
    <Paper elevation={8} className={classes.root}>
      <Box className={classes.shadow}>
        <Box className={classes.containerTypography}>
          {/* <Chip className={classes.chip} size="small" label="Status: aguardando confirmação" /> */}
          <TextStatus style={{
            width: '100%',
          }}/>
        </Box>
        <Box className={classes.containerChips}>
          <Typography variant="h6" style={{ marginRight: 3 }}>
            Meios de contato:
          </Typography>
          {attempts.length < 1 ? (
            <Chip className={classes.chipContact} size="small" label="Sem tentativas" />
          ) : (
            attempts.map(item => (
              <Chip key={item.id} className={classes.chipContact} size="small" label={item.mode} />
            ))
          )}
        </Box>
        <Box className={classes.containerBtns}>
          <Box className={classes.containerBtn}>
            {disabledAddFileIntimation ? (
              <Tooltip title="Necessário intimação" arrow placement="right">
                <span>
                  <IconButton
                    className={classes.iconButton}
                    onClick={() => setOpenModalAddFile(true)}
                    style={{ backgroundColor: '#d7d7d7' }}
                    disabled
                  >
                    <AttachFileIcon style={{ color: '#ededed' }} />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="Anexar intimação" arrow placement="right">
                <IconButton
                  className={classes.iconButton}
                  onClick={() => (write ? setOpenModalAddFile(true) : handleOpenSnackbar())}
                >
                  <AttachFileIcon className={classes.icon} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          <Box className={classes.containerBtn}>
            <Tooltip title="Ver arquivo anexado" arrow placement="left">
              <IconButton className={classes.iconButton} onClick={() => setOpenModalListFile(true)}>
                <DescriptionIcon className={classes.icon} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      {intimations?.length > 0 && (
        <>
          <ModalHistoryIntimation
            open={openHistoryIntimationModal}
            onClose={handleCloseModalHistoryIntimation}
            intimations={intimations}
          />
          <ModalGenerateAndMonitorNoticePublic
            open={openGenerateNoticeModal}
            onClose={handleCloseGenerateNoticeModal}
            inquiry={inquiry}
            intimation={intimations[0]}
            onRefresh={onRefresh}
            getIntimations={getIntimations}
          />
        </>
      )}
    </Paper>
  );
};

export default StatusIntimation;
